<template>
  <div>
    <CompanyPersonCard v-for="person in people" :person="person" :key="person.id" />
  </div>
</template>

<script>
import CompanyPersonCard from "./CompanyPersonCard";

export default {
  props: {
    people: Array
  },

  components: {
    CompanyPersonCard
  }
};
</script>